import "slick-carousel";

import $ from "jquery";

const chartSlider = () => {
    const init = () => {
        slider();
    };

    const slider = () => {
        const el = {
            slick: ".js-ChartSlider",
        };

        if ($(el.slick).length === 0) return;

        /* Slick Js */
        $(el.slick).slick({
            dots: true,
            // appendDots: $(".mi-chart-slider-pagination"),
            arrows: false,
            infinite: false,
            // centerMode: true,
            variableWidth: true,
            slidesToScroll: 1,
            slidesToShow: 2,
            responsive: [
                // {
                //     breakpoint: 480,
                //     settings: {
                //         slidesToShow: 1,
                //         slidesToScroll: 1,
                //     },
                // },
                {
                    breakpoint: 1249,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    };

    init();
};

try {
    chartSlider();
} catch (e) {
    console.error("Chart Slider : ", e);
}
